import UsersPage from "../components/pages/users/UsersPage";
import UsersInvitePage from "../components/pages/users/UsersInvitePage";
import UsersEditPage from "../components/pages/users/UsersEditPage";
import UserInvitations from "../components/pages/users/UserInvitations";

const routes = [
    {
        path: "/users",
        element: <UsersPage />
    },
    {
        path: "/users/invite",
        element: <UsersInvitePage />
    },
    {
        path: "/users/edit/:id",
        element: <UsersEditPage />
    },
    {
        path: "/users/invitations",
        element: <UserInvitations />
    }
];
export default routes;
